<template>
	<div class="About">
		<ul>
			<li v-for="(item,index) in meetings" :key="index">
				<router-link  :to="{ path:'/biaodi',query:{ meeting_id:item.id,page:1,type:'全部' }}" class="List">
				 <!-- <div class="timer"><h1>{{ item.created_at }}</h1><p class="shengming">《拍界官方公告》</p></div> -->

				 	<div class="Img" :style="{'backgroundImage':'url('+item.img+')'}">
				 	
				 	</div>

					 <div class="Container">

						<h2>{{ item.title }}</h2>
						<p class="f16 meeting_text">拍卖企业：拍界官方</p>
						<p class="f16 meeting_text">开始时间：{{ item.start_at }}</p>

						<div>
							<router-link class="f16 meeting-btn" :to="{ path:'/biaodi',query:{ meeting_id:item.id,page:1,type:'全部' }}">标的目录</router-link>
							<router-link class="f16 meeting-btn" :to="{ path:'/biaodiDetails',query:{ id:item.first_subject_id,meeting_id:item.id}}">拍卖大厅</router-link>
						</div>

						<div class="People-lot">
							<p class="People-tab">围观次数：<span class="meetingcount">{{item.view_count*1+item.view_base_count*1}}</span>次</p>
							<p class="People-tab">标的数量：<span class="lotNum">{{item.subject_count}}</span>个</p>
						</div>

					<!-- <p class="go">...></p> -->
				 	</div>	
				</router-link>	
			</li>
		</ul>
	</div>

	
</template>

<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	data (){
	return{
			meetings: []
		}
	 },
	created(){
		// 显示公共栏
		this.$emit('header', true)
		this.$emit('footer', true)
		
		// 请求页面数据
		this.axios.get('https://api.paijie.com/meetings')
		.then((response) => {
			// console.log(response)
			if(response.data.error.code == 0){
				this.meetings = response.data.meetings;
				// console.log(meetings);
			}
		})
		.catch(() => {
				// console.log(response.data.error.message)
		})
		// 页面至顶部
		window.scrollTo(0,0);
	},
	mounted(){
		// console.log('Current Swiper instance object', this.mySwiper);
	},
	computed: {

	}
}
</script>